import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import InfoUnavailable from '../../../../components/common/InfoUnavailable';

const MostCommonBrands = forwardRef(function ({ mostCommonBrands }, ref) {
  return (
    <div ref={ref} className="mb-36 scroll-offset" id='most-common-brands-section'>
      <h4 className="accordion-header">Most Common Brands</h4>

      <div className="accordion-body">
        {mostCommonBrands?.Items?.length ? (
          <div>
            <div className="row">
              <div className="col-sm-6 col-lg-6 col-12 drug-info mb-0">
                <ul className="risk-list">
                  {mostCommonBrands.Items.map((commonBrand, index) => (
                    <li key={`common-brand-${index}`}>
                      <span className="label">
                        {commonBrand.MostCommonBrandDrugDesc}
                      </span>
                      <span
                        className={
                          'answer ' +
                          (commonBrand.MostCommonBrandStatusCodeDesc ===
                          'Active'
                            ? 'active'
                            : '')
                        }
                      >
                        {commonBrand.MostCommonBrandStatusCodeDesc}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ) : (
          <InfoUnavailable />
        )}
      </div>
    </div>
  );
});

MostCommonBrands.propTypes = {
  mostCommonBrands: PropTypes.object.isRequired,
};

MostCommonBrands.displayName = 'MostCommonBrands';

export default MostCommonBrands;
